import themeVariables from "Components/theme/themeVariables";
import { APP_SIZES } from "./constants";
export const pageContentModalWidth = `calc(100vw - ${APP_SIZES.SIDEBAR_MAIN_WIDTH + 4 * parseInt(themeVariables["panel-body-padding"])}px)`;
export const pageContentModalHeight = `calc(100vh - ${APP_SIZES.HEADER_HEIGHT + 4 * parseInt(themeVariables["panel-body-padding"])}px)`;
export const shadingLightestColor = "rgba(17, 34, 50, 0.5)";
export const shadingDarkColor = themeVariables["gray-200"];
